import { createFileRoute } from '@tanstack/react-router'
import { GoalDetailView } from '../../../../components/goals/GoalDetailView'
import { GOAL_TABS, type GoalTab } from '../../../../components/goals/goalTabs'

const asString = (value: unknown) => (typeof value === 'string' ? value : undefined)

export const Route = createFileRoute('/_authenticated/goals/$goalId/')({
  component: GoalDetail,
  validateSearch: (search): { milestone?: string; tab?: GoalTab; planMilestone?: string } => ({
    // The milestone the Summary tab shows, so a milestone view can be linked to directly
    milestone: asString(search.milestone),
    // The open tab, so a page opened from Your Plan can come back to it. Absent: Summary
    tab: GOAL_TABS.find((tab) => tab === search.tab),
    // The milestone Your Plan shows, once the user has moved off the one it opened on
    planMilestone: asString(search.planMilestone),
  }),
})

function GoalDetail() {
  const { goalId } = Route.useParams()
  const { milestone, tab, planMilestone } = Route.useSearch()

  return (
    <GoalDetailView
      goalId={goalId}
      milestoneId={milestone}
      tab={tab}
      planMilestoneId={planMilestone}
    />
  )
}
